module.exports = __webpack_public_path__ + "static/media/FT-MONUMENTO.3aeba954.png";